<template>

  <div v-if="!hasPermission('List Professional')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
      <Toolbar />
    <div class="container-xxl">
      <div class="card w-100">
        <div class="card-header">
          <div class="card-title">
            <div class="d-flex align-items-center position-relative my-1">
          <span class="svg-icon svg-icon-1 position-absolute ms-6">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                    transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
              <path
                  d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                  fill="black"></path>
            </svg>
          </span>
              <input type="text" v-model="search"
                     class="form-control form-control-solid w-250px ps-14"
                     placeholder="Pesquisar ...">
            </div>
          </div>
          <div class="card-toolbar d-flex gap-2">
            <button class="btn btn-flex btn-success" @click="onClickBtnInvite">
              <i class="bi bi-plus-lg"></i> Convidar
            </button>
            <button v-if="hasPermission('Store Professional')" class="btn btn-flex btn-primary"
                    @click="onClickBtnStore">
              <i class="bi bi-plus-lg"></i> Adicionar
            </button>
          </div>
        </div>
        <div class="card-body py-4">

          <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page" href="#" id="tab-nav-professionals"
                 data-bs-toggle="tab" data-bs-target="#nav-professionals">Profissionais</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" id="tab-nav-invites"
                 data-bs-toggle="tab" data-bs-target="#nav-invites">Convites</a>
            </li>
          </ul>

          <hr>

          <div class="tab-content">
            <div class="tab-pane fade show active" id="nav-professionals" role="tabpanel"
                 aria-labelledby="nav-professionals-tab">
              <div class="table-responsive">
                <table class="table table-row-bordered gy-5">
                  <thead>
                  <tr class="fw-bold fs-6 text-muted">
                    <th>Nome</th>
                    <th>E-mail</th>
                    <th>CPF</th>
                    <th>Ativo</th>
                    <th class="text-end">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="professional in professionalsFiltered">
                    <td class="fw-semibold">{{ professional.prof_name }}</td>
                    <td>{{ professional.prof_email }}</td>
                    <td>{{ professional.prof_cpf }}</td>
                    <td>
                      <span class="badge badge-success"
                            v-if="professional.active_prof_place && professional.active">Sim</span>
                      <span class="badge badge-danger" v-else>Não</span>
                    </td>
                    <td class="text-end text-nowrap">
                      <div class="btn-group">
                        <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="hasPermission('Update Professional')"
                                @click="onClickBtnSettings(professional)"
                                data-bs-toggle="tooltip" title="Configurações do profissional">
                          <i class="bi bi-gear"></i>
                        </button>
                        <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="hasPermission('Update Professional') && (professional.id_place_owner === this.place.id_place || professional.id_prof === userAuth.id_prof) || userAuth.is_admin"
                                @click="onClickBtnEdit(professional)" data-bs-toggle="tooltip"
                                title="Editar profissional">
                          <i class="bi bi-pen"></i>
                        </button>

                        <!-- TODO - Somente liberar após criação de método de validação de documentação para a nova especialidade -->
                        <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="hasPermission('Update Professional')  && (professional.id_place_owner === this.place.id_place || professional.id_prof === userAuth.id_prof) || userAuth.is_admin"
                                @click="onClickBtnSpec(professional)" data-bs-toggle="tooltip" title="Especialidades">
                          <i class="bi bi-mortarboard"></i>
                        </button>
                        <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="true || hasPermission('Prof Place Paymethod')"
                                @click="onClickBtnPaymethod(professional)" title="Formas de pagamento">
                          <i class="bi bi-cash-coin"></i>
                        </button>
                        <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="true || hasPermission('Prof Place Insurance')"
                                @click="onClickBtnInsurance(professional)" title="Convênios">
                          <i class="bi bi-hospital"></i>
                        </button>
                        <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="hasPermission('Update Professional')"
                                @click="onClickBtnTaxInfo(professional)" title="Informações Fiscais">
                          <i class="bi bi-receipt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="tab-pane fade" id="nav-invites" role="tabpanel" aria-labelledby="nav-invites-tab">
              <InviteProfessional :searchParam="search" @onSubmit="loadProfessionals"/>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" id="modal_store">
        <div class="modal-dialog modal-lg">
          <form method="post" @submit.prevent="submitFormStore">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Adicionar Profissional</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                     aria-label="Fechar">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">

                  <div class="col-md-12 mb-6 mt-4">
                    <label for="prof_name" class="required form-label required">Nome</label>
                    <input class="form-control form-control-solid"
                           v-model="formStore.prof_name" id="prof_name" required>
                    <small class="text-danger" v-if="formStoreErrors.prof_name">
                      {{ formStoreErrors.prof_name.join('\n') }}
                    </small>
                  </div>

                  <div class="col-md-12 mb-6 mt-4">
                    <label for="prof_email" class="required form-label required">E-mail</label>
                    <input class="form-control form-control-solid"
                           v-model="formStore.prof_email" id="prof_email" required>
                    <small class="text-danger" v-if="formStoreErrors.prof_email">
                      {{ formStoreErrors.prof_email.join('\n') }}
                    </small>
                  </div>

                  <div class="col-md-12 mb-6 mt-4">
                    <label for="prof_cpf" class="required form-label required">
                      CPF
                    </label>
                    <input class="form-control form-control-solid"
                           v-mask="'###.###.###-##'" placeholder="999.999.999-99"
                           v-model="formStore.prof_cpf" id="prof_cpf">
                    <small class="text-danger" v-if="formStoreErrors.prof_cpf">
                      {{ formStoreErrors.prof_cpf.join('\n') }}
                    </small>
                  </div>

                  <div class="col-md-12 mb-6 mt-4">
                    <label for="prof_phone" class="required form-label required">
                      Telefone
                    </label>
                    <input class="form-control form-control-solid"
                           v-mask="['(##) ####-####', '(##) #####-####']"
                           placeholder="(99) 9 9999-9999"
                           v-model="formStore.prof_phone" id="prof_phone" required>
                    <small class="text-danger" v-if="formStoreErrors.prof_phone">
                      {{ formStoreErrors.prof_phone.join('\n') }}
                    </small>
                  </div>

                  <!-- <div class="col-md-12 ms-4 mb-6 mt-4">
                     <div class="row form-check form-switch">
                       <label class="form-check-label" for="active">Ativo?</label>
                       <input class="form-check-input" type="checkbox" role="switch" id="active"
                              v-model="formStore.active">
                     </div>
                   </div> -->

                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                <button type="submit" class="btn btn-primary">Cadastrar</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" id="modal_edit">
        <div class="modal-dialog modal-lg">
          <form method="post" @submit.prevent="submitFormEdit">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Editar profissional</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                     aria-label="Fechar">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body">
                <!-- Navegação por abas -->
                <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                  <li class="nav-item">
                    <a class="nav-link active" data-bs-toggle="tab" href="#kt_modal_edit_professional_basic">
                      <i class="bi bi-person me-2"></i>Dados
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="tab" href="#kt_modal_edit_professional_provider">
                      <i class="bi bi-building me-2"></i>Dados do Prestador
                    </a>
                  </li>
                </ul>

                <!-- Conteúdo das abas -->
                <div class="tab-content" id="kt_modal_edit_professional_tab_content">
                  <!-- Aba Dados -->
                  <div class="tab-pane fade show active" id="kt_modal_edit_professional_basic" role="tabpanel">
                    <div class="row">
                      <div class="col-md-12 mb-6 mt-4">
                        <label for="prof_name" class="required form-label required">Nome</label>
                        <input class="form-control form-control-solid"
                               v-model="formEdit.prof_name" id="prof_name" required>
                        <small class="text-danger" v-if="formEditErrors.prof_name">
                          {{ formEditErrors.prof_name.join('\n') }}
                        </small>
                      </div>

                      <div class="col-md-12 mb-6 mt-4">
                        <label for="prof_email" class="required form-label required">E-mail</label>
                        <input class="form-control form-control-solid"
                               v-model="formEdit.prof_email" id="prof_email" required disabled>
                        <small class="text-danger" v-if="formEditErrors.prof_email">
                          {{ formEditErrors.prof_email.join('\n') }}
                        </small>
                      </div>

                      <div class="col-md-12 mb-6 mt-4">
                        <label for="prof_cpf" class="required form-label required">
                          CPF
                        </label>
                        <input class="form-control form-control-solid"
                               v-mask="'###.###.###-##'" placeholder="999.999.999-99"
                               v-model="formEdit.prof_cpf" id="prof_cpf" required>
                        <small class="text-danger" v-if="formEditErrors.prof_cpf">
                          {{ formEditErrors.prof_cpf.join('\n') }}
                        </small>
                      </div>

                      <div class="col-md-12 mb-6 mt-4">
                        <label for="prof_phone" class="required form-label required">
                          Telefone
                        </label>
                        <input class="form-control form-control-solid"
                               v-mask="['(##) ####-####', '(##) #####-####']"
                               placeholder="(99) 9 9999-9999"
                               v-model="formEdit.prof_phone" id="prof_phone" required>
                        <small class="text-danger" v-if="formEditErrors.prof_phone">
                          {{ formEditErrors.prof_phone.join('\n') }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <!-- Aba Dados do Prestador -->
                  <div class="tab-pane fade" id="kt_modal_edit_professional_provider" role="tabpanel">
                    <div class="row">
                      <div class="col-md-4 mb-6">
                        <label for="provider_document" class="form-label">CPF/CNPJ do Prestador</label>
                        <div class="input-group">
                          <input class="form-control form-control-solid"
                                 v-model="formEdit.provider_document"
                                 v-mask="providerDocumentMask"
                                 id="provider_document"
                                 maxlength="20"
                                 :placeholder="providerDocumentMask === '###.###.###-##' ? '000.000.000-00' : '00.000.000/0000-00'"
                                 @blur="fetchSupplierByDocument">
                          <button class="btn btn-icon btn-light-primary"
                                  type="button"
                                  @click="fetchSupplierByDocument"
                                  :disabled="loadingSupplierByDocument"
                                  title="Buscar dados do fornecedor">
                            <i v-if="loadingSupplierByDocument" class="bi bi-arrow-repeat spinner spinner-sm"></i>
                            <i v-else class="bi bi-search"></i>
                          </button>
                        </div>
                        <small class="text-muted">Digite o CPF/CNPJ e saia do campo ou clique na lupa para preencher automaticamente</small>
                        <small class="text-danger d-block" v-if="formEditErrors.provider_document">
                          {{ formEditErrors.provider_document.join('\n') }}
                        </small>
                      </div>
                      <div class="col-md-6 mb-6">
                        <label for="provider_name" class="form-label">Nome do Prestador</label>
                        <input class="form-control form-control-solid"
                               v-model="formEdit.provider_name"
                               id="provider_name"
                               maxlength="255"
                               placeholder="Nome do prestador">
                        <small class="text-danger" v-if="formEditErrors.provider_name">
                          {{ formEditErrors.provider_name.join('\n') }}
                        </small>
                      </div>
                      <div class="col-md-2 mb-6">
                        <label for="cnes" class="form-label">CNES</label>
                        <input class="form-control form-control-solid"
                               v-model="formEdit.cnes"
                               id="cnes"
                               maxlength="10"
                               placeholder="Código CNES">
                        <small class="text-danger" v-if="formEditErrors.cnes">
                          {{ formEditErrors.cnes.join('\n') }}
                        </small>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 mb-6">
                        <label for="provider_zipcode" class="form-label">CEP</label>
                        <div class="input-group">
                          <input class="form-control form-control-solid"
                                 v-model="formEdit.provider_zipcode"
                                 v-mask="'#####-###'"
                                 id="provider_zipcode"
                                 maxlength="10"
                                 placeholder="00000-000"
                                 @blur="searchProviderZipcode">
                          <button class="btn btn-icon btn-light-primary" 
                                  type="button"
                                  @click="searchProviderZipcode"
                                  :disabled="loadingProviderZipcode">
                            <i v-if="loadingProviderZipcode" class="bi bi-arrow-repeat spinner spinner-sm"></i>
                            <i v-else class="bi bi-search"></i>
                          </button>
                        </div>
                        <small class="text-danger" v-if="formEditErrors.provider_zipcode">
                          {{ formEditErrors.provider_zipcode.join('\n') }}
                        </small>
                      </div>
                      <div class="col-md-5 mb-6">
                        <label for="provider_address" class="form-label">Endereço</label>
                        <input class="form-control form-control-solid"
                               v-model="formEdit.provider_address"
                               id="provider_address"
                               maxlength="255"
                               placeholder="Endereço completo">
                        <small class="text-danger" v-if="formEditErrors.provider_address">
                          {{ formEditErrors.provider_address.join('\n') }}
                        </small>
                      </div>
                      <div class="col-md-2 mb-6">
                        <label for="provider_number" class="form-label">Número</label>
                        <input class="form-control form-control-solid"
                               v-model="formEdit.provider_number"
                               id="provider_number"
                               maxlength="20"
                               placeholder="Número">
                        <small class="text-danger" v-if="formEditErrors.provider_number">
                          {{ formEditErrors.provider_number.join('\n') }}
                        </small>
                      </div>
                      <div class="col-md-2 mb-6">
                        <label for="provider_complement" class="form-label">Complemento</label>
                        <input class="form-control form-control-solid"
                               v-model="formEdit.provider_complement"
                               id="provider_complement"
                               maxlength="100"
                               placeholder="Complemento">
                        <small class="text-danger" v-if="formEditErrors.provider_complement">
                          {{ formEditErrors.provider_complement.join('\n') }}
                        </small>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 mb-6">
                        <label for="provider_neighborhood" class="form-label">Bairro</label>
                        <input class="form-control form-control-solid"
                               v-model="formEdit.provider_neighborhood"
                               id="provider_neighborhood"
                               maxlength="100"
                               placeholder="Bairro">
                        <small class="text-danger" v-if="formEditErrors.provider_neighborhood">
                          {{ formEditErrors.provider_neighborhood.join('\n') }}
                        </small>
                      </div>
                      <div class="col-md-3 mb-6">
                        <label for="id_provider_state" class="form-label">Estado</label>
                        <Dropdown 
                          :options="states"
                          v-model="formEdit.id_provider_state"
                          optionLabel="state_name"
                          optionValue="id_state"
                          :filter="true"
                          appendTo="self"
                          empty-message="Nenhuma opção"
                          empty-filter-message="Nenhuma opção encontrada"
                          class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                          placeholder="Selecione o estado"
                          :showClear="true"
                          style="display: flex; padding: 0.35rem 0.75rem"
                          @change="onProviderStateChange"
                        />
                        <small class="text-danger" v-if="formEditErrors.id_provider_state">
                          {{ formEditErrors.id_provider_state.join('\n') }}
                        </small>
                      </div>
                      <div class="col-md-3 mb-6">
                        <label for="id_provider_city" class="form-label">Cidade</label>
                        <Dropdown 
                          :options="providerCities"
                          v-model="formEdit.id_provider_city"
                          optionLabel="city_name"
                          optionValue="id_city"
                          :filter="true"
                          appendTo="self"
                          empty-message="Nenhuma opção"
                          empty-filter-message="Nenhuma opção encontrada"
                          class="form-control form-control-solid w-full md:w-14rem form-control-sm"
                          placeholder="Selecione a cidade"
                          :showClear="true"
                          style="display: flex; padding: 0.35rem 0.75rem"
                        />
                        <small class="text-danger" v-if="formEditErrors.id_provider_city">
                          {{ formEditErrors.id_provider_city.join('\n') }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                <button type="submit" class="btn btn-primary">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" id="modal_settings">
        <div class="modal-dialog modal-xl">
          <form method="post" @submit.prevent="submitFormSettings">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Configurações - {{ selectedProf && selectedProf.prof_name }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                     aria-label="Fechar">
                  <i class="bi bi-x-lg"></i>
                </div>
              </div>
              <div class="modal-body pt-4">
                <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold mb-8">
                  <li class="nav-item">
                    <a class="nav-link active" aria-current="page" href="#" id="tab-nav-settings-global"
                       data-bs-toggle="tab" data-bs-target="#nav-settings-global">Globais</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" id="tab-nav-settings-spec" data-bs-toggle="tab"
                       data-bs-target="#nav-settings-spec">Por especialidade</a>
                  </li>
                </ul>

                <div class="tab-content">

                  <div class="tab-pane fade show active" id="nav-settings-global" role="tabpanel"
                       aria-labelledby="nav-settings-global-tab">

                    <h4 class="fs-6 fw-bold text-gray-700 mb-4">Agenda</h4>
                    <div class="row g-5 mb-8">
                      <div class="col-md-3">
                        <label for="default_release_time_for" class="required form-label">
                          Liberação de horário padrão
                        </label>
                        <select class="form-select form-select-solid" id="default_release_time_for"
                                v-model="formSettings.default_release_time_for">
                          <option value="B">Online e presencial</option>
                          <option value="O">Online</option>
                          <option value="F">Presencial</option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label for="interval_minutes" class="required form-label">Tempo médio de atendimento</label>
                        <div class="input-group input-group-solid">
                          <input type="number" min="1" placeholder="Ex. 30" id="interval_minutes"
                                 v-model="formSettings.interval_minutes" class="form-control form-control-solid">
                          <span class="input-group-text">min</span>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label for="time_begin" class="required form-label">Início do atendimento</label>
                        <input type="text" v-mask="'##:##'" placeholder="08:00" id="time_begin"
                               v-model="formSettings.time_begin" class="form-control form-control-solid">
                      </div>
                      <div class="col-md-3">
                        <label for="time_end" class="required form-label">Fim do atendimento</label>
                        <input type="text" v-mask="'##:##'" placeholder="12:00" id="time_end"
                               v-model="formSettings.time_end" class="form-control form-control-solid">
                      </div>
                    </div>

                    <h4 class="fs-6 fw-bold text-gray-700 mb-4">Retorno e restrições</h4>
                    <div class="row g-5 mb-8">
                      <div v-if="formSettings.perm_return" class="col-md-3">
                        <label for="has_returning_deadline" class="required form-label">Possui prazo de retorno?</label>
                        <select class="form-select form-select-solid" id="has_returning_deadline"
                                v-model="formSettings.has_returning_deadline">
                          <option value="S">Sim</option>
                          <option value="N">Não</option>
                        </select>
                      </div>
                      <div v-if="formSettings.perm_return && formSettings.has_returning_deadline === 'S'" class="col-md-3">
                        <label for="returning_deadline" class="required form-label">Prazo de retorno da consulta</label>
                        <div class="input-group input-group-solid">
                          <input type="number" min="0" placeholder="Ex. 30" id="returning_deadline"
                                 v-model="formSettings.returning_deadline" class="form-control form-control-solid">
                          <span class="input-group-text">dias</span>
                        </div>
                      </div>
                      <div v-if="formSettings.has_returning_deadline === 'N' || !formSettings.perm_return" class="col-md-3">
                        <label for="min_days_between_scheds" class="required form-label">Prazo para nova consulta</label>
                        <div class="input-group input-group-solid">
                          <input type="number" min="0" placeholder="Ex. 30" id="min_days_between_scheds"
                                 v-model="formSettings.min_days_between_scheds" class="form-control form-control-solid">
                          <span class="input-group-text">dias</span>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label for="min_patient_age" class="form-label">Idade mínima</label>
                        <div class="input-group input-group-solid">
                          <input type="number" min="0" placeholder="Ex. 0" id="min_patient_age"
                                 v-model="formSettings.min_patient_age" class="form-control form-control-solid">
                          <span class="input-group-text">anos</span>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label for="max_patient_age" class="form-label">Idade máxima</label>
                        <div class="input-group input-group-solid">
                          <input type="number" min="0" placeholder="Ex. 120" id="max_patient_age"
                                 v-model="formSettings.max_patient_age" class="form-control form-control-solid">
                          <span class="input-group-text">anos</span>
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <small class="text-muted">Deixe as idades vazias se não houver restrição.</small>
                      </div>
                    </div>

                    <h4 class="fs-6 fw-bold text-gray-700 mb-4">Preferências</h4>
                    <div class="row g-4">
                      <div class="col-md-6">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" v-model="formSettings.show_phone">
                          <span class="form-check-label">Mostrar telefone no site</span>
                        </label>
                      </div>
                      <div class="col-md-6">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" v-model="formSettings.show_address">
                          <span class="form-check-label">Mostrar endereço no site</span>
                        </label>
                      </div>
                      <div class="col-md-6">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" v-model="formSettings.notify_on_new_schedule">
                          <span class="form-check-label">Receber notificação a cada novo agendamento</span>
                        </label>
                      </div>
                      <div class="col-md-6">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" v-model="formSettings.available_to_patient">
                          <span class="form-check-label">Disponível para agendamento pelo paciente</span>
                        </label>
                      </div>
                      <div class="col-md-6">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" v-model="formSettings.accepts_fitted_schedule">
                          <span class="form-check-label">Aceita encaixe na agenda</span>
                        </label>
                      </div>
                      <div class="col-md-6">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" v-model="formSettings.unify_avail"
                                 @change="onChangeUnifyAvail">
                          <span class="form-check-label">Replicar a liberação de agenda para todas as especialidades</span>
                        </label>
                      </div>
                      <div class="col-md-6">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" v-model="formSettings.print_date_on_prescription">
                          <span class="form-check-label">Imprimir data na receita</span>
                        </label>
                      </div>
                      <div class="col-md-6">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" v-model="formSettings.active_prof_place">
                          <span class="form-check-label">Ativo neste local</span>
                        </label>
                      </div>
                    </div>

                    <div class="d-flex justify-content-end gap-2 border-top pt-6 mt-8">
                      <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                      <button type="submit" class="btn btn-primary">Salvar</button>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="nav-settings-spec" role="tabpanel"
                       aria-labelledby="nav-settings-spec-tab">

                    <input type="text" class="form-control form-control-solid mb-6" v-model="searchNewSpecialty"
                           placeholder="Filtrar especialidades ...">

                    <div v-if="!newSpecialtiesFiltered.length" class="text-center text-muted py-10">
                      Nenhuma especialidade encontrada.
                    </div>

                    <div v-for="specialty in newSpecialtiesFiltered" :key="specialty.id_spec"
                         class="card card-bordered mb-6"
                         :class="{ 'border-primary': isSpecialtyDirty(specialty.id_spec) }">
                      <div class="card-header min-h-50px">
                        <div class="card-title">
                          <h3 class="fs-5 fw-bold m-0">{{ specialty.spec_name }}</h3>
                        </div>
                        <div class="card-toolbar" v-if="isSpecialtyDirty(specialty.id_spec)">
                          <span class="badge badge-light-warning">Alterações não salvas</span>
                        </div>
                      </div>
                      <div class="card-body">
                        <h4 class="fs-6 fw-bold text-gray-700 mb-4">Tempo de atendimento</h4>
                        <div class="row g-5 mb-8">
                          <div v-if="!formSettings.unify_avail" class="col-md-4">
                            <label :for="`spec_interval_minutes_${specialty.id_spec}`" class="form-label">
                              Tempo médio da especialidade
                            </label>
                            <div class="input-group input-group-solid">
                              <input type="number" min="1" placeholder="Global" :id="`spec_interval_minutes_${specialty.id_spec}`"
                                     v-model="specialty.interval_minutes" class="form-control form-control-solid">
                              <span class="input-group-text">min</span>
                            </div>
                            <small class="text-muted">Vazio usa o tempo global.</small>
                          </div>
                          <div v-if="specialty.paymeth_intervals?.length"
                               :class="formSettings.unify_avail ? 'col-md-12' : 'col-md-8'">
                            <label class="form-label">Tempo por forma de recebimento</label>
                            <div class="border border-dashed border-gray-300 rounded px-4 py-2">
                              <div v-for="paymeth in specialty.paymeth_intervals" :key="paymeth.id_paymeth"
                                   class="d-flex align-items-center justify-content-between gap-4 py-2">
                                <label :for="`spec_paymeth_interval_${specialty.id_spec}_${paymeth.id_paymeth}`"
                                       class="text-gray-800 mb-0">{{ paymeth.paymeth_name }}</label>
                                <div class="input-group input-group-sm input-group-solid w-150px">
                                  <input type="number" min="1" class="form-control form-control-solid" placeholder="Padrão"
                                         :id="`spec_paymeth_interval_${specialty.id_spec}_${paymeth.id_paymeth}`"
                                         v-model="paymeth.interval_minutes">
                                  <span class="input-group-text">min</span>
                                </div>
                              </div>
                            </div>
                            <small class="text-muted">
                              Vazio usa o tempo da especialidade e, se também estiver vazio, o global.
                            </small>
                          </div>
                        </div>

                        <h4 class="fs-6 fw-bold text-gray-700 mb-4">Retorno e restrições</h4>
                        <div class="row g-5 mb-8">
                          <div v-if="specialty.perm_return" class="col-md-3">
                            <label :for="`spec_has_returning_deadline_${specialty.id_spec}`" class="required form-label">
                              Possui prazo de retorno?
                            </label>
                            <select class="form-select form-select-solid" :id="`spec_has_returning_deadline_${specialty.id_spec}`"
                                    v-model="specialty.has_returning_deadline">
                              <option value="S">Sim</option>
                              <option value="N">Não</option>
                            </select>
                          </div>
                          <div v-if="specialty.perm_return && specialty.has_returning_deadline === 'S'" class="col-md-3">
                            <label :for="`spec_returning_deadline_${specialty.id_spec}`" class="required form-label">
                              Prazo de retorno da consulta
                            </label>
                            <div class="input-group input-group-solid">
                              <input type="number" min="0" placeholder="Ex. 30" :id="`spec_returning_deadline_${specialty.id_spec}`"
                                     v-model="specialty.returning_deadline" class="form-control form-control-solid">
                              <span class="input-group-text">dias</span>
                            </div>
                          </div>
                          <div v-if="specialty.has_returning_deadline === 'N' || !specialty.perm_return" class="col-md-3">
                            <label :for="`spec_min_days_between_scheds_${specialty.id_spec}`" class="required form-label">
                              Prazo para nova consulta
                            </label>
                            <div class="input-group input-group-solid">
                              <input type="number" min="0" placeholder="Ex. 30" :id="`spec_min_days_between_scheds_${specialty.id_spec}`"
                                     v-model="specialty.min_days_between_scheds" class="form-control form-control-solid">
                              <span class="input-group-text">dias</span>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label :for="`spec_min_patient_age_${specialty.id_spec}`" class="form-label">Idade mínima</label>
                            <div class="input-group input-group-solid">
                              <input type="number" min="0" placeholder="Global" :id="`spec_min_patient_age_${specialty.id_spec}`"
                                     v-model="specialty.min_patient_age" class="form-control form-control-solid">
                              <span class="input-group-text">anos</span>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <label :for="`spec_max_patient_age_${specialty.id_spec}`" class="form-label">Idade máxima</label>
                            <div class="input-group input-group-solid">
                              <input type="number" min="0" placeholder="Global" :id="`spec_max_patient_age_${specialty.id_spec}`"
                                     v-model="specialty.max_patient_age" class="form-control form-control-solid">
                              <span class="input-group-text">anos</span>
                            </div>
                          </div>
                          <div class="col-12 mt-2">
                            <small class="text-muted">Deixe as idades vazias para usar a configuração global.</small>
                          </div>
                        </div>

                        <h4 class="fs-6 fw-bold text-gray-700 mb-4">Agendamento</h4>
                        <div class="row g-5">
                          <div class="col-md-6">
                            <label class="form-label d-block">Disponível para agendamento pelo paciente?</label>
                            <div class="d-flex flex-wrap gap-5 mt-2">
                              <label class="form-check form-check-custom form-check-solid">
                                <input class="form-check-input" type="radio" :name="`spec_available_to_patient_${specialty.id_spec}`"
                                       :value="null" v-model="specialty.available_to_patient"/>
                                <span class="form-check-label">Usar global</span>
                              </label>
                              <label class="form-check form-check-custom form-check-solid">
                                <input class="form-check-input" type="radio" :name="`spec_available_to_patient_${specialty.id_spec}`"
                                       value="true" v-model="specialty.available_to_patient"/>
                                <span class="form-check-label">Disponível</span>
                              </label>
                              <label class="form-check form-check-custom form-check-solid">
                                <input class="form-check-input" type="radio" :name="`spec_available_to_patient_${specialty.id_spec}`"
                                       value="false" v-model="specialty.available_to_patient"/>
                                <span class="form-check-label">Indisponível</span>
                              </label>
                            </div>
                          </div>
                          <div class="col-md-6 d-flex flex-column gap-3">
                            <label class="form-check form-switch form-check-custom form-check-solid">
                              <input class="form-check-input" type="checkbox" v-model="specialty.auto_create_bill_to_receive"/>
                              <span class="form-check-label">
                                Criar conta a receber automaticamente
                                <i class="bi bi-info-circle ms-1"
                                   title="Ao agendar uma consulta, será criado um registro no contas a receber automaticamente."></i>
                              </span>
                            </label>
                            <label class="form-check form-switch form-check-custom form-check-solid">
                              <input class="form-check-input" type="checkbox" v-model="specialty.send_confirmation"/>
                              <span class="form-check-label">Enviar confirmação de agendamento</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer d-flex justify-content-end gap-2 py-4" v-if="isSpecialtyDirty(specialty.id_spec)">
                        <button type="button" class="btn btn-sm btn-light" @click="cancelUpdateSpec(specialty.id_spec)">
                          Cancelar
                        </button>
                        <button type="button" class="btn btn-sm btn-primary" @click="updateSpec(specialty.id_spec)">
                          Salvar
                        </button>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          </form>
        </div>
      </div>

      <ModalProfSpec :professional="this.selectedProf"/>
      <ModalProfPlacePayMethod :professional="this.selectedProf"/>
      <ModalProfPlaceInsurance :professional="this.selectedProf"/>
      <ModalProfTaxInfo :professional="this.selectedProf" @saved="onTaxInfoSaved"/>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import InviteProfessional from "./InviteProfessional";
import {mask} from "vue-the-mask";
import ModalProfSpec from "./ModalProfSpec";
import ModalProfPlacePayMethod from "./ModalProfPlacePayMethod";
import ModalProfPlaceInsurance from "./ModalProfPlaceInsurance";
import ModalProfTaxInfo from "./ModalProfTaxInfo";
import Permission from '../../helpers/permission';
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import Dropdown from 'primevue/dropdown';

export default {
  name: "Professionals",
  directives: {
    mask,
  },
  components: {
    ModalProfSpec,
    ModalProfPlacePayMethod,
    ModalProfPlaceInsurance,
    ModalProfTaxInfo,
    InviteProfessional,
    Toolbar,
    Dropdown,
  },
  data() {
    return {
      search: '',
      searchNewSpecialty: '',
      professionals: [],
      selectedProf: '',
      formEdit: {
        id_prof: '',
        prof_name: '',
        prof_email: '',
        prof_phone: '',
        prof_cpf: '',
        active: true,
        provider_document: '',
        provider_name: '',
        provider_address: '',
        provider_number: '',
        provider_complement: '',
        provider_neighborhood: '',
        id_provider_city: null,
        id_provider_state: null,
        provider_zipcode: '',
        cnes: '',
        id_supplier: null,
      },
      states: [],
      providerCities: [],
      loadingProviderZipcode: false,
      loadingSupplierByDocument: false,
      formStore: {
        id_prof: '',
        prof_name: '',
        prof_email: '',
        prof_phone: '',
        prof_cpf: '',
        active: true,
        id_place_owner: '',
      },
      orig_interval_minutes: '',
      formSettings: {
        id_prof: '',
        id_place: '',
        interval_minutes: '',
        returning_deadline: '',
        min_days_between_scheds: '',
        has_returning_deadline: 'S',
        default_release_time_for: '',
        time_begin: '',
        time_end: '',
        show_phone: '',
        show_address: '',
        notify_on_new_schedule: '',
        min_patient_age: '',
        max_patient_age: '',
        active_prof_place: true,
        available_to_patient: true,
        accepts_fitted_schedule: true,
        unify_avail: false,
        print_date_on_prescription: true,
        update_sched_new_interval_minutes: false,
        perm_return: true,
      },
      formSettingsErrors: [],
      formEditErrors: [],
      formStoreErrors: [],
      specialties: [],
      newSpecialties: [],
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    professionalsFiltered() {
      return this.professionals.filter(professional => {
        return professional.prof_name.toLowerCase().includes(this.search.toLowerCase())
      });
    },
    newSpecialtiesFiltered() {
      return this.newSpecialties.filter(newSpecialty => {
        return JSON.stringify(newSpecialty).toLowerCase().includes(this.searchNewSpecialty.toLowerCase())
      });
    },
    providerDocumentMask() {
      const digits = (this.formEdit.provider_document || '').replace(/\D/g, '');
      return digits.length <= 11 ? '###.###.###-##' : '##.###.###/####-##';
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.place && this.place.id_place) {
        this.loadProfessionals();
      } else {
        // Aguardar o place ser carregado
        const unwatch = this.$watch('place', (newPlace) => {
          if (newPlace && newPlace.id_place) {
            this.loadProfessionals();
            unwatch();
          }
        }, { immediate: true });
      }
    });
  },
  methods: {
    date: moment,
    hasPermission(permission) {
      return Permission.has(permission);
    },
    onClickBtnInvite() {
      document.getElementById('tab-nav-invites').click();
      setTimeout(() => {
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_store_invite')).toggle();
      }, 100);
    },
    onClickBtnSettings(professional) {
      this.selectedProf = professional;
      this.orig_interval_minutes = professional.interval_minutes;
      this.formSettings = {
        id_prof: professional.id_prof,
        id_place: professional.id_place,
        interval_minutes: professional.interval_minutes,
        returning_deadline: professional.returning_deadline,
        min_days_between_scheds: professional.min_days_between_scheds,
        has_returning_deadline: professional.returning_deadline > 0 ? 'S' : 'N',
        time_begin: professional.time_begin,
        time_end: professional.time_end,
        show_phone: professional.show_phone,
        show_address: professional.show_address,
        notify_on_new_schedule: professional.notify_on_new_schedule,
        default_release_time_for: professional.default_release_time_for,
        min_patient_age: professional.min_patient_age,
        max_patient_age: professional.max_patient_age,
        active_prof_place: professional.active_prof_place,
        available_to_patient: professional.available_to_patient,
        accepts_fitted_schedule: professional.accepts_fitted_schedule !== undefined ? professional.accepts_fitted_schedule : true,
        unify_avail: professional.unify_avail,
        print_date_on_prescription: professional.print_date_on_prescription !== undefined ? professional.print_date_on_prescription : true,
        perm_return: professional.perm_return,
      };

      this.loadSpecialties(professional.id_prof).then(() => {
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_settings')).toggle();
      });

    },
    onClickBtnStore() {
      document.getElementById('tab-nav-professionals').click();
      this.formStore = {
        prof_name: '',
        prof_email: '',
        prof_phone: '',
        prof_cpf: '',
        active: true,
        id_place_owner: this.place.id_place,
      };
      bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_store')).toggle();
    },
    onClickBtnEdit(professional) {
      this.formEdit = {
        id_prof: professional.id_prof,
        prof_name: professional.prof_name,
        prof_email: professional.prof_email,
        prof_phone: professional.prof_phone,
        prof_cpf: professional.prof_cpf,
        active: professional.active,
        id_place_owner: professional.id_place_owner,
        provider_document: professional.provider_document || '',
        provider_name: professional.provider_name || '',
        provider_address: professional.provider_address || '',
        provider_number: professional.provider_number || '',
        provider_complement: professional.provider_complement || '',
        provider_neighborhood: professional.provider_neighborhood || '',
        id_provider_city: professional.id_provider_city || null,
        id_provider_state: professional.id_provider_state || null,
        provider_zipcode: professional.provider_zipcode || '',
        cnes: professional.cnes || '',
        id_supplier: professional.id_supplier || null,
      };
      
      this.loadStates();
      if (this.formEdit.id_provider_state) {
        this.loadProviderCities();
      } else {
        this.providerCities = [];
      }
      
      bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_edit')).toggle();
    },
    onClickBtnPaymethod(professional) {
      this.selectedProf = professional;
      bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_prof_place_paymethod')).toggle();
    },
    onClickBtnInsurance(professional) {
      this.selectedProf = professional;
      bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_prof_place_insurance')).toggle();
    },
    onClickBtnSpec(professional) {
      this.selectedProf = professional;
      bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_prof_spec')).toggle();
    },
    onClickBtnTaxInfo(professional) {
      this.selectedProf = professional;
      bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_prof_tax_info')).toggle();
    },
    onTaxInfoSaved() {
      // Callback quando as informações fiscais são salvas
      // Pode ser usado para atualizar dados na tela se necessário
    },
    loadProfessionals() {
      if (!this.place || !this.place.id_place) {
        console.warn('Place não disponível ainda');
        return;
      }
      http.get(`/places/${this.place.id_place}/professionals?include_inactive=true`).then((response) => {
        this.professionals = response.data;
      });
    },
    loadSpecialties(profId) {
      return http.get(`/places/${this.place.id_place}/professionals/${profId}/specialties`).then((response) => {
        this.specialties = response.data.map(item => ({...item, has_returning_deadline: item.returning_deadline > 0 ? 'S' : 'N'}));
        this.newSpecialties = this.specialties.map(item => this.cloneSpecialtySettings(item));
      });
    },
    cloneSpecialtySettings(specialty) {
      return JSON.parse(JSON.stringify(specialty));
    },
    specialtySettings(idSpec, list) {
      return list.find(item => item.id_spec === idSpec);
    },
    isSpecialtyDirty(idSpec) {
      const current = this.specialtySettings(idSpec, this.newSpecialties);
      const original = this.specialtySettings(idSpec, this.specialties);
      if (!current || !original) {
        return false;
      }

      return JSON.stringify(current) !== JSON.stringify(original);
    },
    submitFormStore() {
      http.post(`/places/${this.place.id_place}/professionals`, this.formStore).then(_ => {
        this.loadProfessionals();
        this.$store.dispatch('auth/loadProfessionals');

        Alert.toastSuccess("Profissional cadastrado com sucesso.");
        this.formStoreErrors = [];
        this.formStore = {
          id_prof: '',
          prof_name: '',
          prof_email: '',
          prof_phone: '',
          prof_cpf: '',
          active: true,
        };

        bootstrap.Modal.getInstance(document.getElementById('modal_store')).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        if (e.response.data.errors) {
          this.formStoreErrors = e.response.data.errors;
        }
      });
    },
    submitFormEdit() {
      http.put(`/places/${this.place.id_place}/professionals/${this.formEdit.id_prof}`, this.formEdit).then(_ => {
        this.loadProfessionals();
        this.$store.dispatch('auth/loadProfessionals');

        Alert.toastSuccess("Profissional atualizado com sucesso.");
        this.formEditErrors = [];
        this.formEdit = {
          id_prof: '',
          prof_name: '',
          prof_email: '',
          prof_phone: '',
          prof_cpf: '',
          active: true,
          provider_document: '',
          provider_name: '',
          provider_address: '',
          provider_number: '',
          provider_complement: '',
          provider_neighborhood: '',
          id_provider_city: null,
          id_provider_state: null,
          provider_zipcode: '',
          cnes: '',
          id_supplier: null,
        };
        this.providerCities = [];

        bootstrap.Modal.getInstance(document.getElementById('modal_edit')).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        if (e.response.data.errors) {
          this.formEditErrors = e.response.data.errors;
        }
      });
    },
    submitFormSettings() {
      const makeRequest = () => {
        if (this.formSettings.has_returning_deadline === 'N') {
          this.formSettings.returning_deadline = 0;
        }

        http.put(`/places/${this.place.id_place}/professionals/${this.formSettings.id_prof}/settings`, this.formSettings).then(_ => {
          this.loadProfessionals();
          this.$store.dispatch('auth/loadProfessionals');

          Alert.toastSuccess("Configurações atualizadas com sucesso.");
          this.formSettingsErrors = [];
          this.formSettings = {
            id_prof: '',
            id_place: '',
            interval_minutes: '',
            returning_deadline: '',
            min_days_between_scheds: '',
            has_returning_deadline: 'N',
            time_begin: '',
            time_end: '',
            show_phone: '',
            show_address: '',
            notify_on_new_schedule: '',
            min_patient_age: '',
            max_patient_age: '',
            active_prof_place: true,
            available_to_patient: true,
            accepts_fitted_schedule: true,
            unify_avail: false,
            print_date_on_prescription: true,
          };

          bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_settings')).toggle();
        }).catch(e => {
          Alert.toastError(e.response.data.message ?? e.response.data);
          if (e.response.data.errors) {
            this.formSettingsErrors = e.response.data.errors;
          }
        });
      };

      const chkInternalMinutes = () => {
        if (this.orig_interval_minutes !== this.formSettings.interval_minutes) {
          Swal.fire({
            title: 'Intervalo de atendimento',
            text: "Gostaria de ajustar o tempo médio de atendimento dos agendamentos futuros?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, ajustar!',
            cancelButtonText: 'Não',
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: 'btn btn-secondary'
            }
          }).then((result) => {
            if (result.isConfirmed) {
              this.formSettings.update_sched_new_interval_minutes = true;
            }

            makeRequest()
          });
        } else {
          makeRequest();
        }
      };

      chkInternalMinutes();
    },
    onChangeUnifyAvail() {
      // Pergunta ao ligar, não ao salvar: a pessoa vê na hora que os campos
      // por especialidade deixam de valer.
      if (!this.formSettings.unify_avail) {
        return;
      }

      Swal.fire({
        title: 'Replicar a liberação de agenda para todas as especialidades',
        text: "Essa alteração irá unificar o tempo médio de atendimento para todas as especialidades e descartar os intervalos configurados por especialidade, confirma a alteração?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, confirmo!',
        cancelButtonText: 'Não',
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // Igual ao que o salvar fazia antes: agendamentos existentes passam a
          // usar o novo intervalo.
          this.formSettings.update_sched_new_interval_minutes = true;

          return;
        }

        this.formSettings.unify_avail = false;
      });
    },
    remove(id) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/professionals/${id}`).then(_ => {
            this.loadProfessionals();
            this.$store.dispatch('auth/loadProfessionals');

            Alert.toastSuccess("Profissional removido com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    cancelUpdateSpec(idSpec) {
      const index = this.newSpecialties.findIndex(item => item.id_spec === idSpec);
      const original = this.specialtySettings(idSpec, this.specialties);
      if (index === -1 || !original) {
        return;
      }

      this.newSpecialties[index] = this.cloneSpecialtySettings(original);
    },
    updateSpec(idSpec) {
      const index = this.newSpecialties.findIndex(item => item.id_spec === idSpec);
      const original = this.specialtySettings(idSpec, this.specialties);
      if (index === -1 || !original) {
        return;
      }

      const makeRequest = () => {
        console.log(this.newSpecialties[index]);
        if (this.newSpecialties[index].has_returning_deadline === 'N') {
          this.newSpecialties[index].returning_deadline = 0;
          console.log(this.newSpecialties[index].returning_deadline);
        }
        http.put(`/places/${this.place.id_place}/professionals/${this.formSettings.id_prof}/specialties/${this.newSpecialties[index].id_spec}`, this.newSpecialties[index]).then(_ => {
          this.loadSpecialties(this.formSettings.id_prof);
          Alert.toastSuccess("Especialidade atualizada com sucesso.");
        }).catch(e => {
          Alert.toastError(e.response.data.message ?? e.response.data);
        });
      }

      if (this.newSpecialties[index].interval_minutes !== original.interval_minutes) {
        Swal.fire({
          title: 'Intervalo de atendimento',
          text: "Gostaria de ajustar o tempo médio de atendimento dos agendamentos futuros?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, ajustar!',
          cancelButtonText: 'Não',
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: 'btn btn-secondary'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.newSpecialties[index].update_sched_new_interval_minutes = true;
          }

          makeRequest()
        });
      } else {
        makeRequest();
      }
    },
    loadStates() {
      http.get('/states').then((response) => {
        this.states = response.data || [];
      }).catch((error) => {
        console.error('Erro ao carregar estados:', error);
      });
    },
    loadProviderCities() {
      if (!this.formEdit.id_provider_state) {
        this.providerCities = [];
        return Promise.resolve();
      }
      return http.get(`/states/${this.formEdit.id_provider_state}/cities`)
        .then((response) => {
          this.providerCities = response.data || [];
        })
        .catch((error) => {
          console.error('Erro ao carregar cidades:', error);
          this.providerCities = [];
        });
    },
    onProviderStateChange() {
      this.formEdit.id_provider_city = null;
      this.loadProviderCities();
    },
    searchProviderZipcode() {
      if (!this.formEdit.provider_zipcode) {
        return;
      }
      
      const zipcode = this.formEdit.provider_zipcode.replace(/\D/g, '');
      
      if (zipcode.length !== 8) {
        Alert.toastWarning('CEP deve conter 8 dígitos');
        return;
      }
      
      this.loadingProviderZipcode = true;
      
      http.get(`/zipcode/${zipcode}`)
        .then((response) => {
          const data = response.data;
          
          if (data.address) {
            this.formEdit.provider_address = data.address;
          }
          if (data.neighborhood) {
            this.formEdit.provider_neighborhood = data.neighborhood;
          }
          if (data.state && data.state.id_state) {
            this.formEdit.id_provider_state = data.state.id_state;
            this.loadProviderCities().then(() => {
              if (data.city && data.city.id_city) {
                this.formEdit.id_provider_city = data.city.id_city;
              }
            });
          } else if (data.city && data.city.id_city) {
            this.formEdit.id_provider_city = data.city.id_city;
          }
          
          Alert.toastSuccess('CEP encontrado e campos preenchidos!');
        })
        .catch((error) => {
          console.error('Erro ao buscar CEP:', error);
          const message = error.response?.data?.error || 'CEP não encontrado';
          Alert.toastError(message);
        })
        .finally(() => {
          this.loadingProviderZipcode = false;
        });
    },
    fetchSupplierByDocument() {
      const documentDigits = (this.formEdit.provider_document || '').replace(/\D/g, '');
      if (documentDigits.length !== 11 && documentDigits.length !== 14) {
        return;
      }
      if (!this.place || !this.place.id_place) {
        Alert.toastWarning('Estabelecimento não disponível.');
        return;
      }

      this.loadingSupplierByDocument = true;
      this.formEditErrors = { ...this.formEditErrors, provider_document: undefined };

      http.get(`/places/${this.place.id_place}/finances/suppliers/by-document/${encodeURIComponent(documentDigits)}`)
        .then((response) => {
          const data = response.data?.data || response.data;
          if (!data) return;

          this.formEdit.provider_document = data.document || this.formEdit.provider_document;
          this.formEdit.provider_name = data.name || '';
          this.formEdit.provider_zipcode = data.zipcode || '';
          this.formEdit.provider_address = data.street || '';
          this.formEdit.provider_number = data.number || '';
          this.formEdit.provider_complement = data.complement || '';
          this.formEdit.provider_neighborhood = data.neighborhood || '';
          this.formEdit.id_supplier = data.id || this.formEdit.id_supplier;

          if (data.state_id) {
            this.formEdit.id_provider_state = data.state_id;
            this.loadProviderCities().then(() => {
              if (data.city_id) {
                this.formEdit.id_provider_city = data.city_id;
              }
            });
          } else {
            this.formEdit.id_provider_state = null;
            this.formEdit.id_provider_city = null;
            this.providerCities = [];
          }

          Alert.toastSuccess('Dados do prestador preenchidos com sucesso.');
        })
        .catch((error) => {
          const status = error.response?.status;
          const message = error.response?.data?.message;
          if (status === 404) {
            // Não exibir mensagem; campos permanecem em branco
          } else if (status === 422) {
            Alert.toastWarning(message || 'Documento inválido. Use CPF (11 dígitos) ou CNPJ (14 dígitos).');
            if (error.response?.data?.errors?.document) {
              this.formEditErrors = { ...this.formEditErrors, provider_document: error.response.data.errors.document };
            }
          } else if (status === 403) {
            Alert.toastError(message || 'Sem permissão para consultar fornecedores.');
          } else {
            Alert.toastError(message || 'Erro ao buscar fornecedor.');
          }
        })
        .finally(() => {
          this.loadingSupplierByDocument = false;
        });
    },
  },
}
</script>

<style scoped>

</style>